import { useEffect, useRef } from 'react';
import { useInViewport } from 'react-in-viewport';

import { preloadLink } from 'Lib/preload/preload';
import requestIdleCallbackManager from 'Lib/requestIdleCallbackManager';

type UsePreloadBundleOptions = {
  to: string;
  ref: React.RefObject<HTMLElement>;
  viewportOptions?: Parameters<typeof useInViewport>[1];
  viewportConfig?: Parameters<typeof useInViewport>[2];
};

/**
 * Preload route assets for link
 */
const usePreloadLink = ({ to, ref, viewportOptions, viewportConfig }: UsePreloadBundleOptions) => {
  const { inViewport } = useInViewport(ref, viewportOptions, viewportConfig);

  const loaded = useRef<boolean>(false);

  useEffect(() => {
    loaded.current = false;
  }, [to]);

  useEffect(() => {
    if (!loaded.current && inViewport) {
      requestIdleCallbackManager.addTask(() => {
        preloadLink(to, () => {
          loaded.current = true;
        });
      });
    }
  }, [to, inViewport]);
};

export default usePreloadLink;
